<template>
  <div :id="`map-${index}`" style="min-width: 1500px; height: 300px;"></div>
</template>

<script>
export default {
  name: 'RouteMap',
  props: ['index']
}
</script>

